export const habaMyAccountOrderHistory = {
  myOrderHistory: {
    empty : {
      filter: '',
      noOrder : ''
    },
    headline : 'My order overview',
    filter: {
      orderNumber: 'Order number',
      '3months': '3 months',
      '6months': '6 months',
      '12months': '12 months'
    },
    orderItem: {
      headline: {
        prefix: 'Order from'
      },
      details: {
        orderNumber: 'Order number',
        orderValue: 'Order value',
        status: 'Status'
      },
      button: 'Show order details'
    },
    return : {
      headline: 'You would like to return a shipment to us?',
      btnText : 'Return Order'
    }
  },
  orderHistoryDetails: {
    error: 'Sorry, something went wrong.',
    loading: 'The enquiry may take a few seconds, please be patient.',
    backLink : 'Back to order overview',
    downloadInvoice: 'Download Invoice',
    headline : {
      prefix: 'Order',
    },
    info : {
      headline : {
        shipmentTracking: 'Shipment tracking',
        status: 'Status',
        orderDate : 'Order date',
        shippingMethod : 'Shipping method',
        orderTotal : 'Order total',
        deliveryAddress : 'Delivery address',
        paymentAddress : 'Billing address',
        paymentMethod : 'Payment method',
        shipmentCount: 'Number of shipments',
        deliveryDate: 'Delivery date',
        date: 'Date'
      }
    },
    entries : {
      articlePrefix : 'Article',
      singlePrice : 'Unit price',
      totalPrice : 'Total',
      articleNumber: 'Article number: {{code}}',
      amount: 'Quantity: {{quantity}}',
      quantity: 'Quantity',
      btnShowMore : 'Show details',
      canceled : 'canceled',
      noDeliveryDate: 'Date is being determined',
      noTrackingId: 'Tracking in progress',
      componentsHeader: 'This item consists of the following articles:'
    },
    totals : {
      netValue : 'Net value of goods',
      goodValueTotal : 'Net total',
      deliveryCosts : 'Shipping costs gross',
      freightCosts : 'Freight costs gross',
      total: 'Total',
      vatIncluded: 'VAT included',
      includedDiscount: 'Included discount',
      addedDiscountCodes: 'Added discount codes'
    },
    return : {
      headline: 'You would like to return an order?',
      btnText : 'Return Order'
    },
    giftcards: 'Voucher redemption'
  }
};
